export class Ente { 
    id?: number; 
    nome?: string;
}
